import React from 'react';

import { Box, Button, Chip, Grid, Stack, Typography } from '@mui/material';

import { DisclaimerInfoFragment } from 'src/api';
import { Modal } from 'src/components/common';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export const DisclaimerDetailsModal: React.FC = () => {
  const { closeModal, isOpen, args } = useModal<{
    disclaimer: DisclaimerInfoFragment;
  }>(ModalId.DisclaimerDetails);
  const disclaimer = args?.disclaimer;

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  const titles = React.useMemo(() => disclaimer?.titles, [disclaimer?.titles]);

  return (
    <Modal
      title={disclaimer?.name || ''}
      dialogProps={{
        fullWidth: true,
        maxWidth: 'md',
        onClose: onCloseModal,
        open: isOpen,
      }}
    >
      <Box>
        <Box>
          <Grid container spacing={2} mb={2}>
            <Grid size={1}>
              <Typography color="gray" variant="inputLabel">
                Titles:
              </Typography>
            </Grid>
            <Grid mb={2} size={11}>
              <Stack flexWrap="wrap" direction="row" rowGap={1} gap={1}>
                {titles?.map(title => {
                  return (
                    <Chip
                      sx={{ borderRadius: 16, height: 'fit-content', p: '2px 0 2px 0' }}
                      key={title}
                      label={<Typography variant="chip">{title}</Typography>}
                    />
                  );
                })}
              </Stack>
            </Grid>
            <Grid size={1}>
              <Typography color="gray" variant="inputLabel">
                Text:
              </Typography>
            </Grid>
            <Grid size={11}>
              <Typography variant="body1">{disclaimer?.disclaimer}</Typography>
            </Grid>
          </Grid>
        </Box>
        <Box display="flex" justifyContent="center" mt={2}>
          <Button variant="outlined" color="infoButton" onClick={onCloseModal}>
            Close
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
